module.exports = __webpack_public_path__ + "img/normal_icon_all.6c591ab.png";